import React, {useState} from 'react';
import PropTypes from 'prop-types';

//MUI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';

//GEOCOMPONENTS
import SelectInput from '@geomatico/geocomponents/SelectInput';

//BIKENTA
import DialogPanel from '../DialogPanel';

//UTILS
import {useTranslation} from 'react-i18next';
import {REASONS_LABELS} from '../../config';
import grey from '@mui/material/colors/grey';

const AddVisitDialog = ({isAddVisitDialogOpen, isCommunityVisit, onVisitAdd, onDialogClose}) => {

  const {t} = useTranslation();

  const initialVisit = {
    visit_reason: REASONS_LABELS[0].id
  };

  const [activeStep, setActiveStep] = useState(0);
  const [newVisit, setNewVisit] = useState(initialVisit);

  const handleBack = () => setActiveStep(activeStep - 1);

  const handlePropertyChange = (property) => setNewVisit({...newVisit, ...property});
  const handleAddVisit = () => {
    onVisitAdd(newVisit);
    onDialogClose();
  };

  const steps = [
    {
      sublabel: t('Motivo').toUpperCase(),
      sublabelWithSelectedOption: `${t('Motivo')}: ${initialVisit.visit_reason}`,
      content: <Box my={1}>
        <SelectInput
          options={REASONS_LABELS}
          onOptionChange={(value) => handlePropertyChange({visit_reason: value})}
          selectedOptionId={newVisit.visit_reason}
          menuSx={{zIndex: 3000}}
          sx={{width: 300}}
        />
      </Box>
    }
  ];

  return <DialogPanel
    isOpen={isAddVisitDialogOpen}
    onClose={onDialogClose}
    label={t('Añadir Visita').toUpperCase()}
    fullWidth
  >
    {
      isCommunityVisit && <>
        <Typography sx={{ml: 2, color: grey[700], fontStyle: 'italic'}} gutterBottom>{t('Recuerda que estás creando una visita para toda la comunidad.')}</Typography>
        <Typography sx={{ml: 2, color: grey[700], fontStyle: 'italic'}} gutterBottom>{t('Si quieres crear una visita para una Zona de Intervención determinada, seleccionala y añade la visita desde el panel de detalle de la Zona de Intervención.')}</Typography>
      </>
      
    }
    <Stepper activeStep={activeStep} orientation='vertical' sx={{ml: 2, mb: 2}}>
      {
        steps.map(({sublabel, sublabelWithSelectedOption, content}, index) =>
          <Step key={index}>
            <StepLabel>{activeStep > index ? sublabelWithSelectedOption : sublabel}</StepLabel>
            <StepContent>
              {content}
              <Box mt={2}>
                <Button disabled={activeStep === 0} onClick={handleBack}>{t('atrás')}</Button>
                <Button variant='contained' color='secondary' onClick={handleAddVisit}>{t('añadir')}</Button>
              </Box>
            </StepContent>
          </Step>
        )
      }
    </Stepper>
  </DialogPanel>;
};

AddVisitDialog.propTypes = {
  isAddVisitDialogOpen: PropTypes.bool.isRequired,
  isCommunityVisit: PropTypes.bool.isRequired,
  onDialogClose: PropTypes.func.isRequired,
  onVisitAdd: PropTypes.func.isRequired
};

export default AddVisitDialog;

